import React from "react";
import { Show } from "admin-on-rest";
import ActivationDetail from "./Detail";
//export { default as ActivationDetail } from "./Detail";
export { ActivationList } from "./List";

export const ActivationShow = props => (
  <Show {...props}>
    <ActivationDetail {...props} />
  </Show>
);



// WEBPACK FOOTER //
// ./src/activations/index.js